import styled from 'styled-components';
import { Link } from 'react-router-dom';
import React from 'react';

/**
 * Components.
 */
import {
  UptimeGrid,
  UptimeTypography,
  UptimeBox,
} from '@uptime/uptime-component';
import DefaultUptimeTheme from 'utils/lumosTheme';
import Badge from '@mui/material/Badge';

export const TOP_NAV_Z_INDEX = 1300;
export const TOP_NAV_MOBILE_HEIGHT = 150;
export const TOP_NAV_HEIGHT = 64;
export const SECONDARY_MENU_HEIGHT = 64;

/**
 * Wraps profile name and menu chevron.
 */
export const ProfileWrapper = styled(UptimeGrid)`
  cursor: pointer;
  user-select: none;
`;
/**
 * Divider for mobile menu content.
 */
export const MobileMenuDivider = styled.div`
  margin: ${props => props.theme.space[1]}px 0px
    ${props => props.theme.space[2]}px 0px;
  height: 1px;
  background-color: ${props => props.theme.colors.secondary[3]};
`;
/**
 * Styled button for the mobile nav menu
 */
export const MobileNavButton = styled(UptimeTypography).attrs(_ => ({
  kind: 'h6',
}))`
  height: 40px;
  margin: 0px;
  color: ${props => props.theme.colors.secondary[0]};
  font-weight: 500;
  font-size: 16px;
`;

export const StyledSubMenu = styled(UptimeBox)`
  height: 100%;
  display: flex;
  align-items: center;
  font-weight: 500;
  &:hover,
  &:focus {
    cursor: pointer;
  }
`;
export const StyledComingSoonSubMenu = styled(UptimeTypography).attrs(_ => ({
  kind: 'hint',
}))`
  padding-left: 5px;
  color: ${props => props.theme.colors.grayScale[9]};
  height: 20px;
  font-family: Muli;
  letter-spacing: 0;
  line-height: 20px;
`;

/**
 * Styled 'X' for closing mobile nav menu
 * //styled(Box)`
 */
export const MobileNavCloseButton = styled(UptimeGrid)<
  any & React.HTMLProps<HTMLDivElement>
>`
  appearance: none;
  border: none;
  transition: all 0.1s ease-in;
  ${({ theme }) => `
    top: ${theme.space[4]}px;
    right: ${theme.space[4]}px;

    @media screen and (min-width: ${theme.breakpoints.sm}) {
      top: ${theme.space[5]}px;
      right: ${theme.space[5]}px;
    }

    & > svg {
        font-size: 41px;
    }
  `}

  &:hover {
    cursor: pointer;
  }
  as: button;
  position: absolute;
  background-color: transparent;
  color: ${props => props.theme.colors.secondary[0]};
`;
/**
 * Styled menu item for subscribed services that route to internal page
 */
export const InternalNavItemStyled = styled(props => <Link {...props} />)`
  color: ${props => props.theme.colors.secondary[0]};
  &:hover,
  &:focus {
    color: ${props => props.theme.colors.secondary[0]};
  }
`;

export const StyleOutageNotification = styled(UptimeBox)`
  .Toastify__toast {
    padding: 5px;
  }
  .Toastify__close-button {
    padding-top: 5px;
  }
  .Toastify__toast-icon {
    display: none;
  }
  .Toastify__toast-container--top-right {
    top: 5em;
    .Toastify__toast--info {
      border-radius: 6px;
    }
  }
  .outage-icon {
    img {
      width: 30px;
      margin: 0 5px;
    }
  }
  .outage-title {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    margin: 5px 0;
    font-size: 20px;
    line-height: 24px;
    color: #ffffff;
  }
  .outage-content {
    font-size: 12px;
    line-height: 18px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    color: #ffffff;
  }
`;

export const StyledDialogContent = styled.div(
  ({ theme }: { theme: typeof DefaultUptimeTheme }) => `
    text-align: center;
    .confirm-content {
      font-size: ${theme.uptimeFontSizes.desktop.fz9}px;
    }
    .header {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .icon {
      font-size: ${theme.uptimeFontSizes.desktop.fz11}px;
      padding-right: ${theme.uptimeSpace[3]}px;
    }
  `,
);

export const ActionsContainer = styled.div(
  ({ theme }: { theme: typeof DefaultUptimeTheme }) => `
    display: flex;

    .spacing-button {
      padding-right: ${theme.uptimeSpace[5]}px;
    }
  `,
);

export const StyledBadge = styled(Badge)(({ theme }) => ({
  '& > button': {
    color: `${
      theme.uptimeColors?.menuColors.mainMenu?.iconColor ||
      theme.uptimeColors?.menuColors.mainMenu?.badgeIcon?.textColor ||
      theme.uptimeColors.grayScales.white
    } !important`,
  },
  '& .MuiBadge-colorError': {
    backgroundColor: `${
      theme.uptimeColors?.menuColors.mainMenu?.badgeIcon?.dotColor
        ? theme.uptimeColors?.menuColors.mainMenu?.badgeIcon?.dotColor
        : theme.uptimeColors.generalColors.state.danger.light
    } !important`,
  },
  '.MuiBadge-badge': {
    top: theme.uptimeSpace[6],
    right: theme.uptimeSpace[6],
  },
}));

export const StyledTopnavWrapper = styled.div`
  position: sticky;
  top: 0;
  left: 0;
  z-index: ${TOP_NAV_Z_INDEX};
  .content-middle {
    justify-content: ${(props: any) => props.searchBarPostion || 'flex-end'};
  }
`;

export const StyledCart = styled(UptimeBox)(
  ({ theme }: { theme: typeof DefaultUptimeTheme }) => `
  .MuiIconButton-root {
    color: ${theme.uptimeColors.grayScales.white};
  }
`,
);
